import React from "react";

import { constants } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles, { type ClassNames } from "./themes.module.scss";

export type Theme = ClassNames;

type ThemeEnum =
    (typeof constants)["server.cms.constants.BackgroundThemeChoices"];

type ThemeValues = ThemeEnum[keyof ThemeEnum];

interface Themable {
    theme?: Theme | null;
    tag?: keyof React.JSX.IntrinsicElements;
}

/**
 * Functionally: if value is an object with a theme property, cast it to
 * a ThemeValue.
 * Practically: get a StreamField block's theme value, if it exists, in a
 * typesafe way, because it's been placed on a page via the CMS and something
 * else on the page needs to know its value.
 */
export function getTheme(value: unknown): ThemeValues | undefined {
    if (typeof value === "object" && value !== null && "theme" in value) {
        return value.theme as ThemeValues;
    }
}

export const Themed = React.forwardRef<
    HTMLElement,
    Themable & React.HTMLAttributes<HTMLElement>
>(({ theme, tag: Tag = "div", ...props }, ref) => {
    return React.createElement(Tag, {
        ...props,
        className: concatClassNames([styles[theme ?? "navy"], props.className]),
        ref,
    });
});
